import { render, staticRenderFns } from "./StraightResult.vue?vue&type=template&id=45498e19&"
import script from "./StraightResult.vue?vue&type=script&lang=js&"
export * from "./StraightResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports